<template>
    <v-container>
        <v-container v-if="!isLoading">
            <!-- <iframe class="mb-4" ref="pdfFile" :src="pdfSource" type="application/pdf" :width="width" :height="height" />
            <v-btn class="mb-12" @click="toggleFullscreen" color="gray" outlined rounded>открыть на весь экран</v-btn> -->
            <div id="main">
                <div id="inner">
                    <vue-pdf-embed :source="pdfUrl" v-if="pdfUrl" />
                </div>
            </div>
        </v-container>
        <v-skeleton-loader type="card" v-else />
        <v-form ref="form" @submit.prevent="save">
            <v-container v-if="signatories.length && !isLoading">
                <v-row>
                    <v-col>
                        <v-select
                            v-if="!isLoading"
                            :rules="[validationRules.required]"
                            label="Выбрать подписанта"
                            v-model="selectedSignatory"
                            :items="signatories"
                            item-text="name___ru"
                            item-value="record_id"
                        />
                        <v-skeleton-loader v-else type="text" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>Способ подписания:</v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-radio-group row v-model="selectedSignMethod">
                            <v-radio
                                color="gray"
                                v-for="signMethod in availableSignMethods"
                                :key="signMethod.value"
                                :label="signMethod.label"
                                :value="signMethod.value"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <StylusSign ref="StylusSign" v-if="selectedSignMethod === 'stylus'" />
                        <ECPSigner :document="document" v-if="selectedSignMethod === 'eds'" @getEDSData="getEDSData" />
                        <QRCodeSign
                            v-if="selectedSignMethod === 'qrCode'"
                            :document="document"
                            @getQRData="getQRData"
                            :id="details.id"
                            :file_name="'Досудебное уведомление'"
                        />
                    </v-col>
                </v-row>
            </v-container>
            <v-container v-else-if="!isLoading && signatories.length === 0"> <h1 class="text-h6">Документ подписан</h1></v-container>
            <v-row v-if="!isLoading">
                <v-col offset="6">
                    <v-btn @click="goToPreviousStep" color="gray" outlined rounded>Назад</v-btn>
                </v-col>
                <v-col>
                    <v-btn v-if="!signatories.length" color="gray" outlined rounded @click="cancel">Закрыть</v-btn>
                    <v-btn v-else color="gray" outlined rounded @click="cancel">Отмена</v-btn>
                </v-col>
                <v-col v-if="signatories.length">
                    <v-btn type="submit" color="gray" class="white--text" rounded>Сохранить</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import StylusSign from '@/components/sign_document/StylusSign.vue';

const SignTypes = {
    STYLUS: 'stylus',
    EDS: 'eds',
    QRCode: 'qrCode'
};
import ContractsService from '@/services/apiRequests/contracts.service';
import { mapActions, mapGetters } from 'vuex';
import ECPSigner from '@/components/sign_document/EDSSign.vue';
import QRCodeSign from '@/components/sign_document/QRCodeSign.vue';
import SignService from '@/services/apiRequests/sign.service';
import AccountsService from '@/services/apiRequests/accounts.service';
import { validationRules } from '@/utils/validationRules';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
    name: 'SignStep',
    components: { QRCodeSign, StylusSign, ECPSigner, VuePdfEmbed },
    props: {
        details: {
            required: true
        },
        isContract: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            width: '100%',
            height: '484px',
            pdfSource: null,
            pdfUrl: null,
            signatories: [],
            selectedSignatory: null,
            signMethods: [
                { label: 'Стилус', value: SignTypes.STYLUS, show: false },
                { label: 'С помощью ЭЦП', value: SignTypes.EDS, show: false },
                { label: 'QR code', value: SignTypes.QRCode, show: false }
            ],
            selectedSignMethod: SignTypes.STYLUS,
            signData: null,
            isLoading: false
        };
    },
    computed: {
        ...mapGetters('users', ['getUserInfo']),
        validationRules() {
            return validationRules;
        },
        signatory() {
            return this.selectedSignatory === 1 ? 'engineer_sign' : 'consumer_sign';
        },
        availableSignMethods() {
            return this.signMethods.filter(signMethod => signMethod.show);
        }
    },
    methods: {
        ...mapActions('base', ['showMessage']),
        afterCreatedHandler(pdfApp) {
            // to prevent browser tab title changing to pdf document name
            pdfApp.isViewerEmbedded = true;
        },
        async openHandler(pdfApp) {
            this.info = [];
            const info = await pdfApp.pdfDocument.getMetadata().catch(console.error.bind(console));

            if (!info) return;
            const props = Object.keys(info.info);
            props.forEach(prop => {
                const obj = {
                    name: prop,
                    value: info.info[prop]
                };
                this.info.push(obj);
            });
        },
        pagesRenderedHandler(pdfApp) {
            setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = 'page-height'));
        },
        getStylusData() {
            const dataStylus = this.$refs.StylusSign.$refs.signaturePad.saveSignature();
            this.signData = dataStylus.data;
        },
        getQRData(qrData) {
            this.signData = qrData;
        },
        getEDSData(edsData) {
            this.signData = edsData;
        },
        clearForm() {
            if (this.$refs.StylusSign) {
                this.$refs.StylusSign.$refs.signaturePad.clearSignature();
            }
            this.signData = null;
            this.selectedSignatory = null;
            this.signatories = [];
        },
        async save() {
            if (!this.$refs.form.validate()) return false;
            let payload = {};
            payload.record_id = this.details.id;
            payload.is_stylus = this.selectedSignMethod === SignTypes.STYLUS;
            switch (this.selectedSignMethod) {
                case SignTypes.STYLUS:
                    this.getStylusData();
                    break;
                case SignTypes.QRCode:
                    break;
                case SignTypes.EDS:
                    break;
            }

            payload[this.signatory] = this.signData;

            if (this.isContract) {
                await SignService.contractSign(payload);
            } else {
                await SignService.accountSign(payload);
            }
            this.clearForm();
            await this.getSignData();
        },
        goToPreviousStep() {
            this.$emit('goToPreviousStep');
        },
        base64ToBlob(base64, type = 'application/octet-stream') {
            const binStr = atob(base64);
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
            }
            return new Blob([arr], { type: type });
        },
        base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        },
        async getSignData() {
            let response;
            this.isLoading = true;
            if (this.isContract) {
                response = await ContractsService.getContractsPreTrialNoticeToSign(this.details.id);
            } else {
                response = await AccountsService.getContractsPreTrialNoticeToSign(this.details.id);
            }
            this.isLoading = false;
            this.document = response.data['document_to_sign'];
            this.pdfSource = `data:application/pdf;base64,${response.data['document_to_sign']}`;
            const blob = this.base64ToBlob(response.data['document_to_sign'], 'application/pdf');
            this.pdfUrl = URL.createObjectURL(blob);
            if (response.data.signers) {
                response.data.signers.forEach(signer => this.signatories.push(signer));
            }
            const signsAvailable = response.data['sign_types'];
            for (const key in signsAvailable) {
                switch (key) {
                    case 'stylus':
                        this.signMethods[0].show = signsAvailable[key];
                        if (signsAvailable[key]) {
                            this.selectedSignMethod = SignTypes.STYLUS;
                        }
                        break;
                    case 'eds':
                        this.signMethods[1].show = signsAvailable[key];
                        if (signsAvailable[key]) {
                            this.selectedSignMethod = SignTypes.EDS;
                        }
                        break;
                    case 'qr':
                        this.signMethods[2].show = signsAvailable[key];
                        if (signsAvailable[key]) {
                            this.selectedSignMethod = SignTypes.QRCode;
                        }

                        break;
                }
            }
        },
        cancel() {
            this.$emit('cancel');
        }
    },
    mounted() {
        this.getSignData();
    }
};
</script>

<style scoped>
#main {
    display: inline-block;
    width: 100%;
    height: 100%;
    max-height: 100%;
    vertical-align: top;
    overflow: hidden;
}
#inner {
    height: 400px;
    max-height: 400px;
    overflow-y: scroll;
    background: ivory;
}
</style>
